import { action } from "@ember/object"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import styles from "./edit-modal.module.css"

export interface CourseModalModel {
  planbook: Planbook
  rotationCalendar: RotationCalendar
  course: Course
}

export interface CourseEditModalSignature {
  Args: {
    model: CourseModalModel
    order: number
    closeModal: () => void
  }
}

export default class CourseEditModal extends Component<CourseEditModalSignature> {
  readonly styles = styles
  @tracked isSmall = false

  @action
  setSmallWidth() {
    this.isSmall = true
  }
  @action
  setNormalWidth() {
    this.isSmall = false
  }
}
